"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDisplayTime = (time) => {
    const minutes = Math.floor(time / 60) % 60;
    const hours = Math.floor(time / 3600) % 3600;
    const period = time - 12 * 3600 < 0 ? 'AM' : 'PM';
    return `${hours === 0 || hours === 12 ? 12 : hours % 12}:${minutes.toString().length === 1 ? `0${minutes}` : minutes} ${period}`;
};
exports.formatDate = (date) => {
    if (date == null) {
        return null;
    }
    const [year, month, day] = date.split('-');
    return new Date(`${month}/${day}/${year}`);
};
